import { MetypeCommentingWidget } from "@metype/components";
import get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import { isEmpty } from "../utils";
import { FacebookComment } from "./facebook-comment-widget.js";

function generateHostUrl(story = {}) {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
}

class CommentingWidget extends React.Component {
  render() {
    const metypeConfig = get(this.props, ["metype"], {});
    const story = get(this.props, ["story"], {});
    return (
      <>
        {isEmpty(metypeConfig) || !metypeConfig.accountId || !metypeConfig.host ? (
          <FacebookComment story={story} />
        ) : (
          <MetypeCommentingWidget
            host={metypeConfig.host}
            accountId={parseInt(metypeConfig.accountId)}
            pageURL={generateHostUrl(story)}
            primaryColor={metypeConfig.primaryColor}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    metype: get(state, ["qt", "config", "theme-attributes", "metype-config"], {})
  };
}

export const CommentWidget = connect(mapStateToProps)(CommentingWidget);
